"use client";

/**
 * @file Client wrapper that mounts the `LegalConsentGate` inside the
 * `(public-account)` server layout (sign-in, sign-up, awaiting-approval).
 *
 * `hasCustomerSession` is wired to `false` for this route group because the
 * pages here render outside of an authenticated session; if a visitor lands
 * here while already authenticated, the gate's account-path runs on the next
 * shop/account route they visit.
 */
import { LegalConsentGate } from "@/components/legal/LegalConsentGate";

export function PublicAccountConsentMount() {
  return <LegalConsentGate hasCustomerSession={false} />;
}
